import React  from 'react'
import { Switch, Route } from 'react-router-dom'

import AmendPage from './containers/AmendPage'
import DuplicatePage from './containers/DuplicatePage'
import InsertPage from './containers/InsertPage'
import TemplatePage from './containers/TemplatePage'
import UpdatePage from './containers/UpdatePage'

const CustomerOrderUpsertPage = () => (
  <Switch>
    <Route path="/orders/new/:template" component={InsertPage} />
    <Route path="/orders/new" component={TemplatePage} />
    <Route path="/orders/:id/duplicate" component={DuplicatePage} />
    <Route path="/orders/:id/amend" component={AmendPage} />
    <Route path="/orders/:id" component={UpdatePage} />
  </Switch>
)

export default CustomerOrderUpsertPage
